import React from 'react';

export function HouseHeroIllustration() {
  return (
    <svg width="280" height="200" viewBox="0 0 280 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Sky gradient */}
      <defs>
        <linearGradient id="sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e0edff" />
          <stop offset="100%" stopColor="#f0f5ff" />
        </linearGradient>
        <linearGradient id="houseWall" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f1f5f9" />
        </linearGradient>
        <linearGradient id="roof" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
      </defs>

      {/* Background */}
      <rect width="280" height="200" rx="16" fill="url(#sky)" />

      {/* Clouds */}
      <ellipse cx="60" cy="35" rx="28" ry="12" fill="white" opacity="0.7" />
      <ellipse cx="45" cy="33" rx="18" ry="10" fill="white" opacity="0.7" />
      <ellipse cx="220" cy="45" rx="22" ry="9" fill="white" opacity="0.5" />

      {/* Ground */}
      <rect x="0" y="160" width="280" height="40" rx="0" fill="#d1fae5" />
      <rect x="0" y="160" width="280" height="8" fill="#a7f3d0" opacity="0.6" />

      {/* Main house body */}
      <rect x="80" y="90" width="120" height="70" rx="2" fill="url(#houseWall)" stroke="#cbd5e1" strokeWidth="1.5" />

      {/* Roof */}
      <polygon points="70,92 140,45 210,92" fill="url(#roof)" />
      <polygon points="75,92 140,50 205,92" fill="#3b82f6" opacity="0.3" />

      {/* Chimney */}
      <rect x="170" y="52" width="16" height="30" rx="2" fill="#94a3b8" />
      <rect x="167" y="49" width="22" height="6" rx="2" fill="#64748b" />

      {/* Door */}
      <rect x="125" y="115" width="30" height="45" rx="3" fill="#1e40af" />
      <circle cx="149" cy="140" r="2.5" fill="#fbbf24" />
      <rect x="128" y="118" width="24" height="5" rx="1" fill="#2563eb" opacity="0.3" />

      {/* Windows */}
      <rect x="92" y="105" width="22" height="22" rx="2" fill="#bfdbfe" stroke="#93c5fd" strokeWidth="1" />
      <line x1="103" y1="105" x2="103" y2="127" stroke="#93c5fd" strokeWidth="1" />
      <line x1="92" y1="116" x2="114" y2="116" stroke="#93c5fd" strokeWidth="1" />

      <rect x="166" y="105" width="22" height="22" rx="2" fill="#bfdbfe" stroke="#93c5fd" strokeWidth="1" />
      <line x1="177" y1="105" x2="177" y2="127" stroke="#93c5fd" strokeWidth="1" />
      <line x1="166" y1="116" x2="188" y2="116" stroke="#93c5fd" strokeWidth="1" />

      {/* Path to door */}
      <path d="M125,160 L120,170 L100,185 L100,200" fill="none" stroke="#d1d5db" strokeWidth="0" />
      <polygon points="125,160 155,160 150,180 145,200 135,200 120,180" fill="#e2e8f0" opacity="0.7" />

      {/* Garden elements */}
      <circle cx="55" cy="155" r="10" fill="#86efac" />
      <circle cx="48" cy="150" r="8" fill="#4ade80" />
      <rect x="52" y="155" width="3" height="12" fill="#65a30d" />

      <circle cx="230" cy="152" r="12" fill="#86efac" />
      <circle cx="224" cy="147" r="9" fill="#4ade80" />
      <rect x="228" y="153" width="3" height="14" fill="#65a30d" />

      {/* Small flowers */}
      <circle cx="75" cy="157" r="3" fill="#fb923c" />
      <circle cx="82" cy="155" r="2.5" fill="#f472b6" />
      <circle cx="205" cy="156" r="3" fill="#fb923c" />
      <circle cx="212" cy="158" r="2.5" fill="#c084fc" />

      {/* Document overlay icon (bottom right) */}
      <g transform="translate(225, 10)">
        <rect x="0" y="0" width="36" height="44" rx="4" fill="white" stroke="#3b82f6" strokeWidth="1.5" />
        <line x1="8" y1="12" x2="28" y2="12" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" />
        <line x1="8" y1="19" x2="24" y2="19" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" />
        <line x1="8" y1="26" x2="20" y2="26" stroke="#93c5fd" strokeWidth="2" strokeLinecap="round" />
        <circle cx="28" cy="36" r="8" fill="#22c55e" />
        <polyline points="24,36 27,39 33,33" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
}

export function DocumentScanIllustration() {
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="docGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#eff6ff" />
          <stop offset="100%" stopColor="#dbeafe" />
        </linearGradient>
      </defs>

      {/* Document */}
      <rect x="25" y="10" width="70" height="90" rx="6" fill="white" stroke="#93c5fd" strokeWidth="2" />
      <path d="M68,10 L68,30 L95,30" fill="#eff6ff" stroke="#93c5fd" strokeWidth="2" strokeLinejoin="round" />

      {/* Text lines */}
      <line x1="37" y1="42" x2="78" y2="42" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />
      <line x1="37" y1="52" x2="72" y2="52" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />
      <line x1="37" y1="62" x2="75" y2="62" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />
      <line x1="37" y1="72" x2="60" y2="72" stroke="#bfdbfe" strokeWidth="3" strokeLinecap="round" />

      {/* Magnifying glass */}
      <circle cx="80" cy="78" r="18" fill="none" stroke="#3b82f6" strokeWidth="3" />
      <line x1="93" y1="91" x2="108" y2="106" stroke="#3b82f6" strokeWidth="4" strokeLinecap="round" />
      <circle cx="80" cy="78" r="12" fill="#3b82f6" opacity="0.08" />

      {/* Sparkle on glass */}
      <circle cx="74" cy="72" r="2" fill="#93c5fd" />
    </svg>
  );
}

export function ShieldIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <circle cx="12" cy="15" r="0.5" fill="#dc2626" />
    </svg>
  );
}

export function DollarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="6" x2="12" y2="18" />
      <path d="M8.5 9.5c0-1.5 1.5-2.5 3.5-2.5s3.5 1 3.5 2.5-1.5 2.5-3.5 2.5-3.5 1-3.5 2.5 1.5 2.5 3.5 2.5 3.5-1 3.5-2.5" />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      <line x1="8" y1="8" x2="16" y2="8" />
      <line x1="8" y1="12" x2="13" y2="12" />
    </svg>
  );
}

export function HomeIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  );
}

export function UploadCloudIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="cloudGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <path d="M44 44H48C53.52 44 58 39.52 58 34C58 28.48 53.52 24 48 24C47.38 24 46.78 24.06 46.18 24.16C43.82 17.48 37.44 12.8 30 13.02C21.16 13.28 14 20.72 14 29.56V30C9.58 30 6 33.58 6 38C6 42.42 9.58 46 14 46H20" stroke="url(#cloudGrad)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="26,36 32,28 38,36" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="32" y1="28" x2="32" y2="52" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
      {/* Small document icon */}
      <rect x="40" y="44" width="14" height="17" rx="2" fill="#eff6ff" stroke="#93c5fd" strokeWidth="1.5" />
      <line x1="44" y1="50" x2="50" y2="50" stroke="#93c5fd" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="44" y1="54" x2="49" y2="54" stroke="#93c5fd" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function SuccessIllustration() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="24" cy="24" r="22" fill="#dcfce7" stroke="#22c55e" strokeWidth="2" />
      <polyline points="14,24 21,31 34,18" fill="none" stroke="#16a34a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function StepUploadIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="#F5EAD8" stroke="#DDD5C5" strokeWidth="1.5" />
      <rect x="13" y="10" width="14" height="18" rx="2" fill="white" stroke="#4A3220" strokeWidth="1.5" />
      <polyline points="17,22 20,19 23,22" stroke="#B45309" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="20" y1="19" x2="20" y2="26" stroke="#B45309" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="15" y1="14" x2="22" y2="14" stroke="#DDD5C5" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function StepAnalyzeIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="#F5EAD8" stroke="#DDD5C5" strokeWidth="1.5" />
      <circle cx="18" cy="18" r="8" fill="white" stroke="#4A3220" strokeWidth="1.5" />
      <line x1="24" y1="24" x2="30" y2="30" stroke="#4A3220" strokeWidth="2" strokeLinecap="round" />
      <line x1="14" y1="16" x2="22" y2="16" stroke="#B45309" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="14" y1="20" x2="20" y2="20" stroke="#B45309" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function StepResultsIcon() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="#F5EAD8" stroke="#DDD5C5" strokeWidth="1.5" />
      <rect x="12" y="10" width="16" height="20" rx="2" fill="white" stroke="#4A3220" strokeWidth="1.5" />
      <polyline points="16,18 18,20 23,15" stroke="#16a34a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="16" y1="24" x2="24" y2="24" stroke="#DDD5C5" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="16" y1="27" x2="21" y2="27" stroke="#DDD5C5" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function PropertyHeroSmall() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="32" height="32" rx="8" fill="#eff6ff" />
      <path d="M6 14l10-8 10 8v12a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V14z" fill="#3b82f6" opacity="0.15" stroke="#3b82f6" strokeWidth="1.5" />
      <rect x="13" y="19" width="6" height="8" rx="1" fill="#3b82f6" opacity="0.3" />
    </svg>
  );
}

export function ErrorIllustration() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Broken document */}
      <rect x="18" y="8" width="44" height="56" rx="4" fill="#fef2f2" stroke="#fca5a5" strokeWidth="2" />
      <path d="M44,8 L44,22 L62,22" fill="#fee2e2" stroke="#fca5a5" strokeWidth="2" strokeLinejoin="round" />

      {/* X mark */}
      <circle cx="40" cy="42" r="14" fill="#fee2e2" stroke="#f87171" strokeWidth="2" />
      <line x1="34" y1="36" x2="46" y2="48" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="46" y1="36" x2="34" y2="48" stroke="#ef4444" strokeWidth="2.5" strokeLinecap="round" />

      {/* Text lines */}
      <line x1="26" y1="28" x2="38" y2="28" stroke="#fca5a5" strokeWidth="2" strokeLinecap="round" />

      {/* Retry arrow */}
      <path d="M30,68 C30,68 38,62 48,68" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="44,64 48,68 44,72" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function LoadingHouseIllustration() {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="loading-house-svg">
      <defs>
        <linearGradient id="loadRoof" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#3b82f6" />
          <stop offset="100%" stopColor="#2563eb" />
        </linearGradient>
      </defs>

      {/* House body */}
      <rect x="22" y="48" width="56" height="38" rx="2" fill="white" stroke="#cbd5e1" strokeWidth="1.5" />

      {/* Roof */}
      <polygon points="15,50 50,20 85,50" fill="url(#loadRoof)" />

      {/* Door */}
      <rect x="41" y="62" width="18" height="24" rx="2" fill="#1e40af" />
      <circle cx="54" cy="75" r="2" fill="#fbbf24" />

      {/* Windows */}
      <rect x="28" y="58" width="10" height="10" rx="1" fill="#bfdbfe" stroke="#93c5fd" strokeWidth="1" />
      <rect x="62" y="58" width="10" height="10" rx="1" fill="#bfdbfe" stroke="#93c5fd" strokeWidth="1" />

      {/* Scanning line animation */}
      <line x1="18" y1="50" x2="82" y2="50" stroke="#3b82f6" strokeWidth="2" opacity="0.3">
        <animate attributeName="y1" values="25;85;25" dur="2s" repeatCount="indefinite" />
        <animate attributeName="y2" values="25;85;25" dur="2s" repeatCount="indefinite" />
      </line>
    </svg>
  );
}
